import { AfterViewInit, Component, OnDestroy, Input, OnChanges, ɵɵNgOnChangesFeature, SimpleChanges } from '@angular/core';
import { NbThemeService, NB_THEME_OPTIONS } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { CHART_CONFIG} from '../config/baseconfig.component';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple } from '../config/color-palettes';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';

@Component({
  selector: 'nbx-pie-echart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.scss']
})
export class PieEchartsComponent implements AfterViewInit {
  @Input() opts: any = {};
  defaultThemeVariables = defaultTheme.variables; 
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';

  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;

  echartsInstance: any;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    if (this.echartsInstance)
    {
      this.echartsInstance.resize({
        height: event.newHeight
      });
    }
  }


  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
 
  ngAfterViewInit() {
    //Set Defaults
    this.title = (this.titlestr == '') ? {
      text: '',
      subtext: '',
      left: 'center'
    } : JSON.parse(this.titlestr);  

    this.tooltip = (this.tooltipstr == '') ? {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)',
    } : JSON.parse(this.tooltipstr);

    this.legend = (this.legendstr == '') ? {
      orient: 'vertical',
      left: 'left',
      data: ['USA', 'Germany', 'France', 'Canada', 'Russia']
    } : JSON.parse(this.legendstr);
    
    this.series = (this.legendstr == '') ? ([
      {
        name: 'Countries',
        type: 'pie',
        radius: '80%',
        center: ['50%', '50%'],
        data: [
          { value: 335, name: 'Germany' },
          { value: 310, name: 'France' },
          { value: 234, name: 'Canada' },
          { value: 135, name: 'Russia' },
          { value: 1548, name: 'USA' },
        ],
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: this.defaultThemeVariables.itemHoverShadowColor,
          },
        },
        label: {
          normal: {
            textStyle: {
              color: this.defaultThemeVariables.fgText,
            },
          },
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: this.defaultThemeVariables.axisLineColor,
            },
          },
        },
      },
    ]) : JSON.parse(this.seriesstr);

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      grid: {
        width: 800,
        height: 500
      },
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      series: this.series
    }
   
  }
  ngOnChanges(changes: SimpleChanges) {

    console.log("update");
    console.log(changes);

    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      series: this.series
    }

  }

  onChartInit(e: any) {
    this.echartsInstance = e;
    console.log('on chart init:', e);
  }

  private updateOptions(opt, value) {
    console.log(opt)
    console.log(value)
    this[opt] = JSON.parse(value);
    console.log(this.tooltip);

    this.options[opt] = this[opt];

    console.log(this.options);  
  }

  // ngOnDestroy(): void {
  //   this.themeSubscription.unsubscribe();
  // }
} 